import typeOf from './type-of';
const is = {
    nullish(value) {
        return value === null || value === undefined;
    },
    string(value) {
        return typeOf(value) === 'string';
    },
    number(value) {
        return typeOf(value) === 'number';
    },
    object(value) {
        return typeOf(value) === 'object';
    },
    array(value) {
        return Array.isArray(value);
    },
};
export default is;
//# sourceMappingURL=is.js.map